export default {
  ALL_SELECTED: 'ALL_SELECTED',
  ONE_OR_MORE_SELECTED: 'ONE_OR_MORE_SELECTED',
  NONE_SELECTED: 'NONE_SELECTED',
};
